var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.requestLoading),expression:"requestLoading"}],style:({
    width: _vm.width,
  }),attrs:{"value":_vm.value,"multiple":_vm.multiple,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event)},"change":_vm.changeHanlder}},_vm._l((_vm.specList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.specName,"value":item.id}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15644a45","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommoditySpecSelect.vue
// module id = null
// module chunks = 